// extracted by mini-css-extract-plugin
export var h1 = "styles-module--h1--6a1e2";
export var h2 = "styles-module--h2--605a3";
export var h3 = "styles-module--h3--1b24e";
export var h4 = "styles-module--h4--2be62";
export var h5 = "styles-module--h5--efd65";
export var h6 = "styles-module--h6--f4fd9";